<div class="obg-m-suspicious-login-content">
	<p>{{ "suspicious-login.info.enter-code" | translate }}</p>
	<mat-form-field>
		<input
			matInput
			placeholder="{{ 'suspicious-login.enter-code' | translate }}"
			type="tel"
			#verificationCodeControl="ngModel"
			[(ngModel)]="verificationCode"
			name="verificationCode"
			test-id="suspicious-login-code"
			required
			obgNumeric
			minlength="6"
			maxlength="6"
		/>
	</mat-form-field>
	<obg-common-validation-renderer [input]="verificationCodeControl" translationPrefix="suspicious-login.code">
	</obg-common-validation-renderer>

	<p class="error" *ngIf="showErrorMessage">{{ "suspicious-login.info.verify.fail" | translate }}</p>
</div>

<div class="obg-m-suspicious-login-actions">
	<button
		mat-flat-button
		color="accent"
		test-id="suspicious-login-validate-btn"
		(click)="validatePin.emit(verificationCodeControl.value)"
		[disabled]="!verificationCodeControl.valid"
	>
		{{ "suspicious-login.validate-code" | translate }}
	</button>

	<p>
		<a test-id="suspicious-login-resend-pin" (click)="resendPin.emit()">{{
			"suspicious-login.resend-code" | translate
		}}</a>
	</p>
</div>
